import React, { Component } from "react";
import LinkList from "./LinkList";
import About from "./About";
import CreateLink from "./CreateLink";
import Header from "./Header";
import Footer from "./Footer";
import { Switch, Route, Redirect } from "react-router-dom";
import Login from "./Login";
import Search from "./Search";
import Account from "./Account";
import EditAccount from "./EditAccount";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import LinkDetails from "./LinkDetails";
import CommentDetails from "./CommentDetails";
import EditComment from "./EditComment";
import ReplyDetails from "./ReplyDetails";
import EditReply from "./EditReply";
import Guidelines from "./Guidelines";
import Faq from "./Faq";

class App extends Component {
  render() {
    return (
      <div className="app">
        <Header />
        <div className="ph3 pt1 pb3 background-gray mh-100">
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/top/1" />} />
            <Route exact path="/top/:page" component={LinkList} />
            <Route exact path="/about" component={About} />
            <Route exact path="/create" component={CreateLink} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/account/:id" component={Account} />
            <Route exact path="/editaccount" component={EditAccount} />
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <Route exact path="/faq" component={Faq} />
            <Route exact path="/guidelines" component={Guidelines} />
            <Route exact path="/search" component={Search} />
            <Route exact path="/new/:page" component={LinkList} />
            <Route exact path="/link/:id" component={LinkDetails} />
            <Route exact path="/comment/:id" component={CommentDetails} />
            <Route exact path="/editcomment/:id" component={EditComment} />
            <Route exact path="/:link/reply/:id" component={ReplyDetails} />
            <Route exact path="/editreply/:id" component={EditReply} />
          </Switch>
        </div>
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js